import { render } from "./EditPublicationLogoModal.vue.js?vue&type=template&id=1da9121e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EditPublicationLogoModal.vue?vue&type=template&id=1da9121e"
import script from "./EditPublicationLogoModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EditPublicationLogoModal.vue?vue&type=script&lang=js"
export * from "./EditPublicationLogoModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EditPublicationLogoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/EditPublicationLogoModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1da9121e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1da9121e', __exports__)) {
    api.reload('1da9121e', __exports__)
  }
  
  module.hot.accept("./EditPublicationLogoModal.vue.js?vue&type=template&id=1da9121e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EditPublicationLogoModal.vue?vue&type=template&id=1da9121e", () => {
    api.rerender('1da9121e', render)
  })

}


export default __exports__